import {Button, Link, ListItemIcon, Menu, Stack, useTheme} from '@mui/material';
import React, {useRef} from 'react';

import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {StyledMenuItem} from './styles';
import {SaveToCalendarProps} from './types';
import generateGoogleCalendarUrl from '../../utils/generateGoogleCalendarUrl';
import handleDownloadIcsCalendarFile from '../../utils/handleDownloadIcsCalendarFile';

const {myAppointmentDetails} = translations['pt-br'].privateFlow.myAppointments;

export function SaveToCalendar({calendarEvent, dataTagId}: SaveToCalendarProps) {
	const {isMobile} = useMediaQueries();
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const theme = useTheme();
	const buttonRef = useRef<HTMLButtonElement>(null);
	const buttonWidth = buttonRef.current?.clientWidth;

	function handleClick(event: React.MouseEvent<HTMLButtonElement>) {
		setAnchorEl(event.currentTarget);
	}
	function handleClose() {
		setAnchorEl(null);
	}

	return (
		<Stack width={isMobile ? '100%' : 'auto'}>
			<Button
				ref={buttonRef}
				variant="outlined"
				id="add-to-calendar-button"
				aria-controls={open ? 'basic-menu' : undefined}
				fullWidth
				aria-haspopup="true"
				aria-expanded={open ? 'true' : undefined}
				onClick={handleClick}
				endIcon={<Icon name="event-filled" color={theme.palette.primary.main} size={24} />}
				data-tag-id={dataTagId}>
				{myAppointmentDetails.saveAppointment}
			</Button>
			<Menu
				id="basic-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				slotProps={{
					list: {
						sx: {
							minWidth: buttonWidth,
						},
						'aria-labelledby': 'add-to-calendar-button',
					},
				}}>
				<Link
					href={generateGoogleCalendarUrl(calendarEvent)}
					rel="noopener noreferrer"
					underline="none"
					target="_blank">
					<StyledMenuItem onClick={handleClose}>
						<ListItemIcon>
							<Icon name="google-calendar" color={theme.palette.primary.main} />
						</ListItemIcon>
						Google
					</StyledMenuItem>
				</Link>
				<StyledMenuItem
					onClick={() => {
						handleDownloadIcsCalendarFile(calendarEvent);
						handleClose();
					}}>
					<ListItemIcon>
						<Icon name="outlook" color={theme.palette.primary.main} />
					</ListItemIcon>
					Outlook
				</StyledMenuItem>
				<StyledMenuItem
					onClick={() => {
						handleDownloadIcsCalendarFile(calendarEvent);
						handleClose();
					}}>
					<ListItemIcon>
						<Icon name="apple-filled" color={theme.palette.primary.main} />
					</ListItemIcon>
					Apple
				</StyledMenuItem>
			</Menu>
		</Stack>
	);
}
